export default function quickAddController() {
  const quickAdd = document.querySelector('.js-sticky-quick-add');

  if (!quickAdd) {
    return;
  }

  const quantityInput = quickAdd.querySelector('.quantity__input');

  const quickAddForm = quickAdd.querySelector('.quick-add__form');

  const mainSubmitButton = document.querySelector('product-info .product-form__submit');

  if (mainSubmitButton) {
    cloneMainSubmitButton();

    const mutationObserver = new MutationObserver((entries) => {
      cloneMainSubmitButton();
    });

    mutationObserver.observe(mainSubmitButton, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.js-sticky-quick-add-button')) {
        setTimeout(() => {
          mainSubmitButton.dispatchEvent(new Event('click', { bubbles: true }));
        }, 0);
      }
    });
  }

  function cloneMainSubmitButton() {
    const quickAddButton = mainSubmitButton.cloneNode(true);
    quickAddButton.removeAttribute('id');
    quickAddButton.removeAttribute('type');
    quickAddButton.removeAttribute('name');
    quickAddButton.removeAttribute('mr-click');
    quickAddButton.classList.add('clone');

    quickAddButton.classList.add('js-sticky-quick-add-button');

    quickAddForm.innerHTML = '';
    quickAddForm.appendChild(quickAddButton);
  }

  // Grab all the .add-to-cart-button elements
  const addToCartButtons = document.querySelectorAll('.add-to-cart-button');
  // This Set holds the currently visible buttons
  const visibleButtons = new Set();

  // Intersection observer setup
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleButtons.add(entry.target);
        } else {
          visibleButtons.delete(entry.target);
        }
      });

      quickAdd.classList.toggle('hidden', visibleButtons.size > 0);
    },
    {
      threshold: 0,
    }
  );

  // Observe each button
  Array.from(addToCartButtons)
    .filter((button) => !button.classList.contains('js-sticky-quick-add-button'))
    .forEach((button) => observer.observe(button));
}
